export default function (proposals, labels) {
  return proposals.map(({ guid, answer, ...rest }) => ({
    guid,
    label: labels[guid].label,
    value: labels[guid].value,
    answer: answer ? { ...labels[answer], guid: answer } : undefined,
    ...rest,
  }));
}
